<template>
  <div class="content ">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <div class="row">
                <div class="col-10">
                  <h4 class="card-title">Bayiiler</h4>
                  <p class="card-category">Yönettiğiniz ve partnerlik yapılan bayileri buradan daha kolay yönetebilirsiniz.</p>
                </div>
                <div class="col-2">
                  <button type="submit" class="btn btn-success btn-fill float-right mr-3" @click="createNew()">
                    Yeni Bayi Ekle
                  </button>
                </div>

              </div>

            </template>


            <table class="table table-hover table-striped">
              <thead>
                <slot name="columns">
                  <tr>
                    <th v-for="column in tableColumns" :key="column">{{ column }}</th>
                  </tr>
                </slot>
              </thead>
              <tbody>
                <tr v-for="(dealer) in dealers" :key="dealer._id">
                  <slot :row="dealer">
                    <td>{{ dealer.code }}</td>
                    <td>{{ dealer.title }}</td>
                    <td><button @click="openDeleteModal(dealer)"><i class="nc-icon nc-simple-remove"></i></button></td>
                    <td><button @click="editDealer(dealer._id)"><i class="nc-icon nc-settings-tool-66"></i></button>
                    </td>
                  </slot>
                </tr>
              </tbody>
            </table>
            <nav aria-label="...">
              <ul class="pagination text-center" style="margin-left: 45%;">

                <li class="page-item"
                  v-for="i of (pagination.totalPages > 1 ? Array.from(Array(pagination.totalPages).keys()).slice(pagination.currentPage > 3 ? pagination.currentPage - 3 : 0, pagination.currentPage + pagination.layOutMax) : [0])"
                  :class="pagination.currentPage == i + 1 ? 'active' : ''" :key="i" @click="paginationGet(i + 1)"><a
                    class="page-link">{{ i + 1 }}</a></li>



              </ul>
            </nav>
          </card>

        </div>


        <div class="modal fade show bg-gray" tabindex="-1"
          :style="deleteModal.isOpened == true ? 'display: block;' : 'display: none;'" aria-modal="true" role="dialog">
          <div class="modal-dialog" v-if="deleteModal.dealer">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLiveLabel">Bayiyi silmek istediğinize emin misiniz?</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                  @click="deleteModal.isOpened = false">
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div class="modal-body">
                <label><strong>Bayi Kodu:</strong> {{ deleteModal.dealer.code }}</label><br>
                <label><strong>Bayi Adı:</strong> {{ deleteModal.dealer.title }}</label><br>
                <label><strong>Şehir:</strong> {{ deleteModal.dealer.city }}</label><br>

              </div>
              <div class="modal-footer">

                <button type="button" @click="openDeleteModal(null)" class="btn btn-secondary"
                  data-dismiss="modal">Kapat</button>
                <button type="button" @click="deleteDealer(deleteModal.dealer._id)" class="btn btn-primary">Sil!</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";


const tableColumns = ['Bayii Kodu', 'Bayii Adı', 'Sil', 'Düzenle']
export default {
  components: {
    Card
  },
  data() {
    return {
      tableColumns,
      dealers: [],
      pagination: {
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 10,
        layOutMax: 3
      },
      queryText: '',
      deleteModal: {
        isOpened: false,
        dealer: null
      },
      searchInterval: null
    }
  },
  mounted() {
    this.getDealers();

  },
  methods: {
    paginationGet(i) {
      this.pagination.currentPage = Number(i);
      this.getDealers();
      window.scroll({ top: 0, behavior: "smooth" })
    },
    getDealers() {
      let q = { title: { $regex: this.queryText, $options: 'i' } };
      let p = {};
      let o = { skip: (this.pagination.currentPage - 1) * this.pagination.itemsPerPage, limit: this.pagination.itemsPerPage, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('dealer', query).then((res) => {
        if (res.success == true) {
          this.dealers = res.dealers;
          this.pagination.totalPages = Math.ceil(res.count / this.pagination.itemsPerPage);
        } else {
          console.log('error');
        }
      })
    },
    deleteDealer(_id) {
      CollectionService.deleteItem('dealer', _id).then((res) => {
        this.notifyVue('bottom', 'right', 'danger', ` ${this.deleteModal.dealer.title} bayi silindi.`)
        this.deleteModal.isOpened = false;
        this.deleteModal.dealer = null;
        this.getDealers();
      })
    },
    openDeleteModal(dealer) {
      this.deleteModal.isOpened = !this.deleteModal.isOpened
      this.deleteModal.dealer = dealer;
    },
    editDealer(_id) {
      this.$router.push(`/admin/dealers/${_id}`);
    },
    createNew() {
      this.$router.push(`/admin/dealers/create`);
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    }
  }
}
</script>
<style></style>